import { isSameDay, parseISO } from 'date-fns';
import { getDateString } from 'utils';
import { appConstants } from 'utils/global-constants';

export const getPerformanceDate = (dateString) => getDateString(dateString);

export const filterPerformanceTimesBySelectedDate = (dateSelected, performanceTimes) => {
  if (!dateSelected) return;
  return performanceTimes.filter((times) => {
    const parsedDateSelected = dateSelected;
    const parsedPerformanceTime = parseISO(times.PerformanceDateTime);
    return isSameDay(parsedDateSelected, parsedPerformanceTime);
  });
};

export const isUserLoggedIn = (membershipUrl) =>
  membershipUrl?.includes(appConstants.accountMembershipUrl);

export const getLoginRedirectUrl = window.location.href.replace(window.location.origin, '');
